/*** IMPORTS FROM imports-loader ***/
var jQuery = require("jquery");
var $ = require("jquery");

import React from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { routerActions } from "react-router-redux";
import { injectIntl, intlShape } from "react-intl";
import { Panel, Button, Table } from "react-bootstrap";
import IntlMsg from "lorautils/intl/IntlMsg";
import ShowIf from "loracoms/ShowIf";
import TablePagerTDM from "loracoms/TablePagerTDM";
import SearchInput from "loracoms/SearchInput";
import LoadingTable from "loracoms/LoadingTable";
import Checkbox from "loracoms/Checkbox";
import { updateNodes } from "loraactions/tdm";
import { pageParams, updateMarks } from "lorautils/pagerUtil";
import callAPI from "@/api/callAPI";
import PageSizer from "loracoms/PageSizer";
import { parseContent } from "../util";
import NodeRow from "./NodeRow";
import TablePagers from "loracoms/TablePagers";
import CreateNode from "./CreateNode";
import DeleteNodes from "./DeleteNodes";
import ResetNodes from "./ResetNodes";
import ResetNode from "./ResetNode";
import styles from "./styles.scss";

const kLimit = 10;
const kMarksKey = "nodeMarks";
const kTypeKey = "nodeTypeFilter";
const kRouteAction = ["POP", "REPLACE"];
const propTypes = {
  intl: intlShape.isRequired,
  network: PropTypes.string.isRequired,
  routerAction: PropTypes.string.isRequired,
  typesJSON: PropTypes.object.isRequired,
  pushState: PropTypes.func.isRequired,
  updateNodes: PropTypes.func.isRequired,
  tdmGateways: PropTypes.object.isRequired,
};

class Node extends React.Component {
  constructor(props) {
    super(props);
    this.intlMsg = new IntlMsg(props.intl, "network.tdm.node");
    const { types } = parseContent(props.typesJSON);
    const options = types.nodetypes
      ? _.map(types.nodetypes, (n) => ({ value: n.type, label: n.type }))
      : [];
    this.state = {
      list: [],
      status: "",
      deleteNode: {},
      checked: [],
      limit: 20,
      network: props.network,
      tdmGateways: props.tdmGateways,
      options: _.concat(
        [{ label: this.intlMsg.msg("nodetype.all"), value: "" }],
        options
      ),
    };
    this.mark = 0;
    this.marks = [];
    this.nodetype = "";
    this.fallback = this.fallback.bind(this);
    this.editSucceed = this.editSucceed.bind(this);
    this.handlePaging = this.handlePaging.bind(this);
    this.onChangeSearch = this.onChangeSearch.bind(this);
    this.onSearchNodeType = this.onSearchNodeType.bind(this);
    this.onCheckedAll = this.onCheckedAll.bind(this);
    this.checkedSingle = this.checkedSingle.bind(this);
    this.handleReset = this.handleReset.bind(this);
    this.handleChangePageSize = this.handleChangePageSize.bind(this);
    this.handleChangeMark = this.handleChangeMark.bind(this);
  }

  componentDidMount() {
    if (_.includes(kRouteAction, this.props.routerAction)) {
      this.marks = pageParams.getMarks(kMarksKey) || [];
      this.nodetype = pageParams.getFilter(kTypeKey) || "";
    }
    this.onLoadData();
    if (!_.isEmpty(this.state.tdmGateways)) {
      this.handleTdmGtws(this.state.tdmGateways);
    }
  }

  componentWillReceiveProps({ network, typesJSON, tdmGateways }) {
    if (network !== this.props.network) {
      this.setState({ network });
    }
    if (!_.isEqual(typesJSON, this.props.typesJSON)) {
      const { types } = parseContent(typesJSON);
      let options = types.nodetypes
        ? _.map(types.nodetypes, (n) => ({ value: n.type, label: n.type }))
        : [];
      options = _.concat(
        [{ label: this.intlMsg.msg("nodetype.all"), value: "" }],
        options
      );
      this.setState({ options });
    }
    if (!_.isEqual(tdmGateways, this.props.tdmGateways)) {
      this.handleTdmGtws(tdmGateways);
    }
  }

  componentWillUnmount() {
    pageParams.setMarks(this.marks, kMarksKey);
    pageParams.setFilter(this.nodetype, kTypeKey);
  }

  onLoadData(length) {
    this.setState({ status: "pending" });
    const { limit } = this.state;

    callAPI({
      endpoint: "/tdmng/nodes",
      query: {
        limit: length || limit,
        mark: this.mark,
        typ: this.nodetype,
        q: this.q,
      },
    })
      .then((res) => {
        const { list, more, mark } = res;
        this.marks = updateMarks(this.marks, mark);
        this.setState({ list, more, mark: this.marks, status: "success" });
      })
      .catch(() => {});
  }

  onDelSuccess() {
    this.mark = 0;
    this.resetMark();
    this.onLoadData();
  }

  onSearchNodeType(nodetype) {
    this.nodetype = nodetype;
    this.resetMark();
    this.setState({ selected: nodetype });
    this.onLoadData();
  }

  onChangeSearch(e) {
    this.q = e.target.value;
    this.setState({ search: this.q });
    this.mark = 0;
    if (this.timer) {
      clearTimeout(this.timer);
    }
    this.timer = _.delay(() => {
      this.resetMark();
      this.onLoadData();
    }, 250);
  }

  onCheckedAll(e) {
    let { checked } = this.state;
    const { list } = this.state;
    if (e) {
      checked = [];
      list.forEach((l) => {
        checked = _.concat(checked, [l.id]);
      });
    } else {
      checked = [];
    }
    this.setState({ checked });
  }

  handleTdmGtws(gtws) {
    const { list = [] } = gtws;
    let gatewayOptions = _.map(list, (l) => {
      const { memo = "{}" } = l;
      const newMemo = JSON.parse(memo) || {};
      return { label: newMemo.name1, value: l.id };
    });
    gatewayOptions = _.concat(
      [{ label: this.intlMsg.msg("bind.default"), value: "" }],
      gatewayOptions
    );
    this.setState({ gatewayOptions });
  }

  resetMark() {
    this.mark = 0;
    this.marks = [];
    this.setState({ reset: new Date().valueOf() });
  }

  checkedAll() {
    const { list, checked } = this.state;
    return list.length > 0 && list.length === checked.length;
  }

  handlePaging(mark) {
    this.mark = mark;
    this.setState({ checked: [] });
    this.onLoadData();
  }

  fallback(deleteNode) {
    this.resetMark();
    this.onLoadData();
    if (deleteNode) {
      this.setState({ deleteNode });
    }
    this.props.updateNodes(new Date().valueOf());
  }

  editSucceed(data) {
    let { list } = this.state;
    list = _.map(list, (l) => {
      if (l.id === data.id) {
        return { ...l, ...data };
      }
      return l;
    });
    this.setState({ list });
    this.props.updateNodes(new Date().valueOf());
  }

  checkedSingle(e, id) {
    if (this.checkedTimer) {
      clearTimeout(this.checkedTimer);
    }

    this.checkedTimer = _.delay(() => {
      let { checked } = this.state;
      if (e) {
        checked = _.concat(checked, [id]);
      } else {
        checked = _.filter(checked, (c) => c !== id);
      }
      this.setState({ checked });
    }, 250);
  }

  handleReset(n) {
    this.setState({ resetNode: n, showSingleReset: true });
  }

  renderTable() {
    const { status, list, checked, gatewayOptions = [] } = this.state;
    const thead = (
      <thead>
        <tr>
          <th>
            <Checkbox
              id="all"
              checked={this.checkedAll()}
              onChange={(e) => this.onCheckedAll(e)}
            />
          </th>
          <th>{this.intlMsg.msg("name")}</th>
          <th>DevEUI</th>
          <th>{this.intlMsg.msg("nodetype")}</th>
          <th>SF</th>
          <th>{this.intlMsg.msg("gateway.bind")}</th>
          <th>{this.intlMsg.msg("gateway.name")}</th>
          <th>{this.intlMsg.msg("remark")}</th>
          <th>{this.intlMsg.msg("reset")}</th>
          <th>{this.intlMsg.msg("delete")}</th>
        </tr>
      </thead>
    );
    if (status === "success") {
      return (
        <Table className="aisz-table-light" striped>
          {thead}
          <tbody>
            {_.map(list, (l) => (
              <NodeRow
                key={l.id}
                data={l}
                checked={checked}
                gatewayOptions={gatewayOptions}
                editSucceed={this.editSucceed}
                onDeleteSucceed={this.fallback}
                onChangeChecked={this.checkedSingle}
                onReset={this.handleReset}
              />
            ))}
          </tbody>
        </Table>
      );
    }
    const rows = Math.max(1, list.length);
    return (
      <LoadingTable
        className="aisz-table-light"
        striped
        bordered
        rows={rows}
        cols={10}
      >
        {thead}
      </LoadingTable>
    );
  }

  // 改变页面显示数量
  handleChangePageSize(length) {
    this.setState({ limit: length });
    this.mark = 0;
    this.onLoadData(length);
  }

  //翻页
  handleChangeMark(flag) {
    const { limit } = this.state;
    if (flag) {
      //下一页
      this.mark += limit;
    } else {
      //上一页
      this.mark -= limit;
      this.mark = this.mark < 0 ? 0 : this.mark;
    }
    this.onLoadData();
  }

  render() {
    const {
      list,
      status,
      network,
      options,
      selected = this.nodetype,
      mark = "",
      reset = 0,
      deleteNode,
      search = "",
      checked,
      resetNode = {},
      gatewayOptions = [],
      more = false,
      showCreate = false,
      showDelete = false,
      showReset = false,
      showSingleReset = false,
      limit,
    } = this.state;

    const header = (
      <div>
        {this.intlMsg.msg("title")}
        <Button
          bsStyle="aisz-danger"
          disabled={!network || !checked.length}
          className={styles.addBtn}
          onClick={() => this.setState({ showDelete: true })}
        >
          <i className="halflings halflings-trash" />
          &nbsp;
          {this.intlMsg.msg("batch.delete")}
        </Button>
        <Button
          bsStyle="aisz-warning"
          disabled={!network || !checked.length}
          className={styles.addBtn}
          onClick={() => this.setState({ showReset: true })}
        >
          <i className="fa fa-repeat" />
          &nbsp;
          {this.intlMsg.msg("batch.reset")}
        </Button>
        <Button
          bsStyle="aisz-primary"
          disabled={!network}
          className={styles.addBtn}
          onClick={() => this.props.pushState("/network/tdm/batch/nodes")}
        >
          <i className="fa fa-arrow-circle-right" />
          &nbsp;
          {this.intlMsg.msg("batch")}
        </Button>
        <Button
          bsStyle="aisz-success"
          disabled={!network}
          onClick={() => this.setState({ showCreate: true })}
          className={styles.addBtn}
        >
          <span className="glyphicons glyphicons-plus" aria-hidden="true" />
          &nbsp;
          {this.intlMsg.msg("add")}
        </Button>
      </div>
    );
    return (
      <Panel bsStyle="aisz-white" header={header}>
        <div className={styles.search}>
          <SearchInput
            autoFocus
            placeholder={this.intlMsg.msg("remark.placeholder")}
            value={search}
            onChange={this.onChangeSearch}
          />
          <div>
            {_.map(options, (o, idx) => (
              <a
                key={idx}
                className={`${styles.label} ${
                  selected === o.value ? styles.active : ""
                }`}
                onClick={() => this.onSearchNodeType(o.value)}
              >
                <i className="fa fa-circle" />
                &nbsp;
                {o.label}
              </a>
            ))}
          </div>
        </div>
        {this.renderTable()}
        <ShowIf if={status === "success" && !list.length}>
          <div className={styles.noData}>{this.intlMsg.msg("nodata")}</div>
        </ShowIf>
        <ShowIf if={list.length > 0}>
          <div>
            <div className={styles.pager}>
              <PageSizer
                pageSize={limit}
                onChange={this.handleChangePageSize}
                options={[20, 100, 500]}
              />
            </div>
            <div className={styles.pagers}>
              {/*               <TablePagerTDM
                status={status}
                mark={mark}
                more={more}
                reset={reset}
                onPrev={this.handlePaging}
                onNext={this.handlePaging}
              /> */}
              <TablePagers
                status={status}
                mark={this.mark}
                more={more}
                change={this.handleChangeMark}
              />
            </div>
          </div>
        </ShowIf>
        <CreateNode
          show={showCreate}
          deleteNode={deleteNode}
          gatewayOptions={gatewayOptions}
          addSucceed={this.fallback}
          onHide={() => this.setState({ showCreate: false })}
        />
        <DeleteNodes
          showModal={showDelete}
          checkedNodes={checked}
          onDelSuccess={() => this.onDelSuccess()}
          onCancel={() => this.setState({ showDelete: false })}
        />
        <ResetNodes
          showModal={showReset}
          checkedNodes={checked}
          onCancel={() => this.setState({ showReset: false })}
        />
        <ResetNode
          showModal={showSingleReset}
          node={resetNode}
          onCancel={() => this.setState({ showSingleReset: false })}
        />
      </Panel>
    );
  }
}

Node.propTypes = propTypes;

const mapStateToProps = (state) => ({
  typesJSON: state.tdm.setting,
  tdmGateways: state.tdm.updateTdmGateways,
});

const mapDispatchToprops = {
  updateNodes,
  pushState: routerActions.push,
};

export default connect(mapStateToProps, mapDispatchToprops)(injectIntl(Node));




// WEBPACK FOOTER //
// ./src/containers/Network/coms/TDMView/Node/index.jsx